import { render, staticRenderFns } from "./Alerting.vue?vue&type=template&id=64af5e58&scoped=true&"
import script from "./Alerting.vue?vue&type=script&lang=ts&"
export * from "./Alerting.vue?vue&type=script&lang=ts&"
import style0 from "./Alerting.vue?vue&type=style&index=0&id=64af5e58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.3_vue-template-compiler@2.7.15_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64af5e58",
  null
  
)

export default component.exports